<template>
  <div class="popup" v-if="christmasSaledShow" v-cloak>
       <div class="content"  id='christmasSaled'>
            <div class="christmasSaled-close" @click="closePage()"></div>
            <img class="christmasSaled-img" :src="require('../../../assets/images/newYear-2023/img_title_'+lang+'.png')">
            <div class="christmasSaled-img-discount" :style="getDiscountPosition()">
                <span v-if="lang=='cn'">{{(10-num/10).toFixed(1)}}</span>
                <span v-if="lang!='cn'">{{num+"%"}}</span>
            </div>
            <div class="christmasSaled-box">
                <div class="christmasSaled-top">
                    <span>{{$t('language.christmas.popupTitle')}}</span>
                </div>
                <div class="christmasSaled-title" :style="getTitleByLang()">{{$t('language.christmas.pageTitle',{'num':num})}}</div>
                <div class="christmasSaled-tip">{{$t('language.christmas.paysysTitle')}}</div>
                <div class="christmasSaled-fun">
                    <div class="action-finger"></div>
                    <div class="christmasSaled-button" @click="switchToPay()">
                        <span>{{$t('language.christmas.saledBtn')}}</span>
                    </div>
                    <div class="christmasSaled-bottom-tips">
                        <div class="christmasSaled-bottom-tip">
                            <div>{{$t('language.christmas.popupTip1')}}</div>
                        </div>
                        <div class="christmasSaled-bottom-tip">
                            <div>{{$t('language.christmas.popupTip2')}}</div>
                            <div class="ask">
                                <div class="plan-questionTxt">{{$t('language.christmas.popupTip2Append')}}</div>
                            </div>
                        </div>
                        <div class="christmasSaled-bottom-tip">
                            <div>{{$t('language.christmas.popupTip3')}}</div>
                        </div>
                        <div class="christmasSaled-bottom-tip">
                            <div>{{$t('language.christmas.popupTip4')}}</div>
                            <div class="ask">
                                <div class="plan-questionTxt">{{$t('language.christmas.popupTip4Append')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    data () {
        return {
            user: null,
            christmasSaledShow: false,
            timer:[],
            timerExpired: false,
            num: 71,//默认折扣71
            lang: commonUtils.getLocaleToIndex(localStorage.getItem("locale")),
        }
    },
    mounted(){
        this.user = commonUtils.getUser();
    },
    methods: {
        getDiscountPosition() {
            var style;
            switch (this.lang) {
                case "de":
                    style = "left: 195Px;top: 562Px;"
                    break;
                case "fr":
                    style = "left: 176Px;top: 560Px;font-size: 28Px;"
                    break;
                case "pt":
                    style = "left: 134Px;top: 559Px;font-size: 32Px;"
                    break;
                case "es":
                    style = "left: 240Px;top: 561Px;font-size: 32Px;"
                    break;
                case "it":
                    style = "left: 188Px;top: 558Px;font-size: 34Px;"
                    break;
                case "jp":
                    style = "left: 210Px;top: 504Px;font-size: 34Px;"
                    break;
                case "cn":
                    if(this.num==86){
                        style = "left: 245Px;top: 510Px;"
                    }else{
                        style = "left: 245Px;top: 510Px;"
                    }
                    break;
                case "tw":
                    style = "left: 195Px;top: 512Px;font-size: 34Px;"
                    break;
                default:
                    break;
            }
            return style
        },
        getTitleByLang() {
            var style;
            switch (this.lang) {
                case "de":
                    style = "font-size: 32Px;line-height: 40Px;"
                    break;
                default:
                    break;
            }
            return style
        },
        showPopup(user){
            this.user = user;
            this.christmasSaledShow = true;
            if(!this.user.vip){
                //免费用户
                this.num = 71;
            }else if(this.user.payType!="Yearly"&&this.user.payType!="Lifetime"){
                //年以下
                this.num = 71;
            }else if(this.user.payType=="Yearly"&&this.user.payLevel>1){
                //获取用户套餐信息
                this.Utils.doSubscriptionPostRequest('get_by_user', { ud: this.user.id }).then(res => {
                    if(res.nowScheme){
                        //有等效id使用等效id
                        let vipId = res.nowScheme.equivalentVip?res.nowScheme.equivalentVip:res.nowScheme.id;
                        if(vipId=="2990c54096364a38a0e115f5602385be"){
                            //年1
                            this.num = 82;
                        }else{
                            //年2
                            this.num = 87;
                        }
                    }
                });
            }else if(this.user.payType!="Lifetime"){
                //无限用户
                this.num = 91;
            }
        },
        closePage(){
            var that = this;
            var notice = $('.upgrade-button').offset();
            $('#christmasSaled').animate({
                left:notice.left+115,
                top:notice.top+4,
                marginLeft:0,
                marginTop:0,
                height:0,
                width:0
            },1300);
            let t = setTimeout(function () {
                that.christmasSaledShow = false;
                clearTimeout(t);
            }, 1200);
        },
        switchToPay(){
            this.user = commonUtils.getUser();
            this.timerExpired = commonUtils.getTimerExpired(commonstate.activityEndedTimer)
            if (this.user.vip && this.user.payLevel <= 1&&this.user.payType == 'Lifetime') {
                this.$toast({
                    text: this.$t('language.rightTopBanner.lifeTimeNotice'),
                    type: 'success',
                    idValue: "rightContBan"
                });
                this.christmasSaledShow = false;
            } else {
                this.christmasSaledShow = false;
                // if(this.timerExpired){
                //     this.$router.push('/mc_project/paySysActivity');
                // }else{
                    this.$router.push('/mc_project/paySys');
                // }
            }
        },
    },

}
</script>

<style scoped>
#christmasSaled{
    width: 980Px;
    height: 632Px;
    border: 0;
    background: url("../../../assets/images/christmasSaled-2022/bg_Pop-ups.png") no-repeat;
}

.christmasSaled-close {
    width: 36Px;
    height: 36Px;
    position: absolute;
    background: url("../../../assets/images/christmasSaled-2022/icon_close_normal.png") no-repeat;
    right: -14Px;
    top: -14Px;
    cursor: pointer;
}

.christmasSaled-close:hover {
    background: url("../../../assets/images/christmasSaled-2022/icon_close_hover.png") no-repeat;
}

.christmasSaled-img{
    float: left;
    margin-top: 35Px;
}

.christmasSaled-img-discount{
    position: absolute;
    top: 561Px;
    left: 229Px;
    font-size: 36Px;
    font-family: Myanmar Text;
    font-weight: bold;
    line-height: 0;
    color: #FFFFFF;
    transform: skewY(-2deg);
}

.christmasSaled-box{
    user-select: none;
    float: right;
    width: 480Px;
    margin-right: 15Px;
    margin-top: 16Px;
    text-align: center;
    display: flex;
    flex-direction: column;
    font-family: Arial;
}

.christmasSaled-top{
    font-size: 22Px; 
    line-height: 22Px;
    font-weight: bold;
    color: #D61A00;
    margin: 32Px auto 24Px;
}

.christmasSaled-title{
    color: #03031A;
    font-size: 36Px;
    font-weight: bold;
    line-height: 44Px;
    margin: 0 24Px;
}

.christmasSaled-tip{
    margin: 24Px auto 20Px;
    font-size: 18Px;
    font-weight: 400;
    line-height: 0px;
    color: #018E40;
}

.christmasSaled-fun {
    width: fit-content;
    margin: auto;
}

.action-finger {
    margin: auto;
    width: 42Px;
    height: 85Px;
    background: url("../../../assets/images/christmasSaled-2022/img_finger.png") no-repeat;
    animation:fingerJump 2.4s infinite;
    background-position-y: 10Px;
}

/**动画效果**/

@keyframes fingerJump {
    from {
        background-position-y: 0Px;
    }
    15% {
        background-position-y: 18Px;
    }
    30% {
        background-position-y: 0Px;
    }
    45% {
        background-position-y: 18Px;
    }
    60% {
        background-position-y: 0Px;
    }
    to {
        background-position-y: 0Px;
    }
}

.christmasSaled-button {
    cursor: pointer;
    min-width: 330Px;
    height: 60Px;
    background: linear-gradient(270deg, #E13920 0%, #C20000 100%);
    box-shadow: 0px 6Px 4Px rgba(227,0,0,0.16);
    border-radius: 30Px;
}

.christmasSaled-button span {
    margin: 0 40Px;
    font-size: 24Px;
    font-weight: bold;
    line-height: 60Px;
    color: #FFFFFF;
}


.christmasSaled-bottom-tips {
    text-align: left;
    position: relative;
    margin-top: 28Px;
}

.christmasSaled-bottom-tip {
    font-size: 13Px;
    font-weight: bold;
    line-height: 17Px;
    color: #928582;
    margin-bottom: 4Px;
    display: flex;
}

.christmasSaled-bottom-tip div{
    margin-left: 26Px;
}

.christmasSaled-bottom-tip::before {
    width: 14Px;
    height: 14Px;
    display: inherit;
    content: "";
    background: url("../../../assets/images/christmasSaled-2022/icon_tick.png") no-repeat;
    position: absolute;
}

.ask{
  width: 15Px;
  height: 15Px;
  display: inline-block;
  background: url("../../../assets/images/christmasSaled-2022/icon_hint.svg") no-repeat;
  cursor: pointer;
  margin-left: 5Px !important;
  margin-top: 1Px;
  position: relative;
}

.ask:hover .plan-questionTxt {
  display: block;
}

.plan-questionTxt {
  text-align: left;
  display: none;
  position: absolute;
  width: 255Px;
  border: 1Px solid #5562b4;
  border-radius: 3Px;
  left: -10Px !important;
  top: 10Px !important;
  background: #fff;
  z-index: 3;
  font-size: 12Px;
  box-sizing: border-box;
  padding: 5Px;
  line-height: 20Px;
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/christmas_saled_popup.vue